module.exports = __webpack_public_path__ + "img/house.2419680b.svg";